import { _colorText, _sizeText } from "../../core/core";
import { Text } from "../texts/text";
import "./InfoCardJob.css";

export interface InfoCardJobProps {
  title: string;
  column?: boolean;
  text?: string;
  children?: React.ReactNode;
}

export const InfoCardJob: React.FC<InfoCardJobProps> = ({
  title,
  column = false,
  text,
  children,
  ...props
}) => {
  const classInfo = column ? "card-job-b-column" : "card-job-b-row";
  return (
    <div className={classInfo}>
      <Text size={_sizeText.m} color={_colorText.neutral}>
        {title}
      </Text>
      {text && (
        <Text size={_sizeText.m} color={_colorText.black}>
          {text}
        </Text>
      )}
      {children}
    </div>
  );
};
